<template>
  <component
    :is="svgImage"
    :style="{ height: 'auto', width: width }"
    :class="`text-${color}`"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'
import type { ImageTypes } from './imageTypes'

const {
  image,
  color = 'primary',
  width = '200px',
} = defineProps<{
  image: ImageTypes
  color?: string
  width?: string
}>()

const svgImage = defineAsyncComponent(() => import(`./images/${image}-img.vue`))
</script>
